<template>
  <div>
    <el-input class="search-el" size="small" v-model="query.title" placeholder="标题"></el-input>
    <el-button type="primary" size="small" @click="getList()" :loading="loading">
      查询
    </el-button>
    <el-button type="primary" size="small" @click="createInfo()" >
      添加话题
    </el-button>
    <el-row>
      <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
        <el-table-column label="封面图" align="center">
          <template slot-scope="{row}">
            <img :src="row.img_url" style="width:40px" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" align="center"></el-table-column>
        <el-table-column prop="sort" label="排序" align="center"></el-table-column>
        <el-table-column prop="moment_amount" label="动态数量" align="center"></el-table-column>
        <el-table-column prop="views" label="阅读" align="center"></el-table-column>
        <el-table-column prop="updated_at" label="修改时间" align="center" ></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{row}">
            <el-button type="primary" size="small" @click="updateHandle(row)">
              修改
            </el-button>
            <el-button type="danger" size="small" @click="deleteTopic(row.topic_id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    :close-on-click-modal='false'
    :close-on-press-escape='false'
    width="50%">
    <el-form :model="topicTemp" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="封面图">
        <el-upload
          class="avatar-uploader"
          action="/backend/community/uploadImg"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="topicTemp.img_url" :src="topicTemp.img_url" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="topicTemp.title" maxlength="30" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows:15 }" v-model="topicTemp.intro" maxlength="200" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="topicTemp.sort"></el-input>
      </el-form-item>
      <el-form-item label="阅读数量">
        <el-input v-model="topicTemp.views"></el-input>
      </el-form-item>
      <el-form-item>
        <!-- <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button> -->
        <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="create == false ? updateTopic() : createTopic()" :loading="updateLoading">确 定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
  </div>
</template>

<script>
import {
  topicList,
  createTopic,
  deleteTopic,
  updateTopic
} from "@/api/moment";
import { PrefixSource } from 'webpack-sources';

export default {
  data: function() {
    return {
      create: false,
      list: [],
      dialogVisible:false,
      loading: false,
      updateLoading: false,
      total: 0,
      topicTemp: {
        img_url:'',
        title:'',
        intro:'',
        sort:0,
        views:0,
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ]
      },
      query: {
        page: 1,
        limit: 20,
        title: ""
      }
    };
  },
  created: function() {
    this.getList();
  },
  methods: {
    tempReset(){
      this.topicTemp =  {
        img_url:'',
        title:'',
        intro:'',
        sort:0,
        views:0,
      }
    },
    createInfo(){
      this.create = true
      this.dialogVisible = true
      this.tempReset()
    },
    createTopic(){
      this.updateLoading = true
      createTopic(this.topicTemp).then(response => {
        this.updateLoading = false
        if(response.status === '2000'){
          this.tempReset()
          this.$message.success(response.message);
          this.getList();
          this.dialogVisible = false
        }
      }).catch(err => {
        this.updateLoading = false
      });
    },
    updateTopic(){
      this.updateLoading = true
      updateTopic(this.topicTemp).then(response => {
        this.updateLoading = false
        console.log(response)
        if(response.status === '2000'){
          this.$message.success(response.message);
          this.getList();
          this.dialogVisible = false
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if(res.code != 1){
        this.$message.error('上传图片失败');
      }else{
        this.topicTemp.img_url = res.data
      }
    },
    beforeAvatarUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error('上传图片大小不能超过 1MB!');
      }
      return isLt1M;
    },
    updateHandle(row){
      this.create = false;
      this.topicTemp = Object.assign({}, row)
      this.dialogVisible = true
    },
    deleteTopic(id) {
      this.$confirm("此操作将删除该话题, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteTopic({
          topic_id: id
        }).then(response => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        });
      });
    },
    ref() {
      window.history.go(0);
    },
    getList() {
      this.loading = true;
      topicList(this.query).then(response => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    }
  }
};
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>